// extracted by mini-css-extract-plugin
export default {"level3FieldRow":"itemScreenFieldRow_level3FieldRow__g-LA9","fieldRowContainer":"itemScreenFieldRow_fieldRowContainer__TNN5q"};